export { default as useUserLocale } from './useUserLocale';
